// Billing B3.0a. Browser copy of functions/helper/booking-status.js: the fixed
// steps of a booking (`bookings/{id}.status`).
// functions/test/booking-status-copy.test.js fails if the two copies differ.

export const BOOKING_STATUS = {
  RESERVED: 'reserved', // first amount paid, the rest is due
  PAID: 'paid', // paid in full
  DONE: 'done', // the event is over (set by B6.4)
  DEPOSIT_RETURNED: 'depositReturned', // set by B6.4
  CANCELLED: 'cancelled'
};
